import React from 'react';
import PropTypes from 'prop-types';
import Table from './Table';
import './index.scss';
import FACheckupFooter from './FACheckupFooter';
import { connect } from 'react-redux';
import {
  REDUCER_NAME,
  fetchFACheckup,
  getCurrentCompares,
  fetchLookupItem,
  resetCheckUpData,
} from '../../reducer';
import { compose } from 'redux';
import { withComponentId } from '../../../../common/ComponentIdContext';

class FACheckUp extends React.Component {
  fetchData = () => {
    const { fetchFACheckup, searchParams, componentId } = this.props;
    const { code = 'AAA' } = searchParams;
    fetchFACheckup(componentId, { OrganCode: code }, searchParams.isBanking);
  };

  componentDidMount() {
    this.fetchData();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const {
      faCheckupData,
      componentId,
      fetchLookupItem,
      resetCheckUpData,
    } = this.props;
    if (this.props.locale !== prevProps.locale) {
      resetCheckUpData(componentId);
      this.fetchData();
    }
    const isFirstFetch =
      Object.keys(faCheckupData.listFaCheckupByTicker).length &&
      !Object.keys(prevProps.faCheckupData.listFaCheckupByTicker).length;
    if (isFirstFetch) {
      const currentCompares = getCurrentCompares(componentId);
      if (!Object.keys(currentCompares).length) {
        return;
      }
      Object.keys(currentCompares).forEach(position => {
        fetchLookupItem(position, currentCompares[position], componentId);
      });
    }
  }

  render() {
    return (
      <div className="fa-checkup-wrapper d-flex flex-fill flex-column">
        <Table />
        <FACheckupFooter />
      </div>
    );
  }
}

const mapStateToProps = (state, { componentId }) => {
  return {
    locale: state.i18n.locale,
    searchParams:
      state[REDUCER_NAME].listMultiComponent[componentId].searchParams,
    faCheckupData:
      state[REDUCER_NAME].listMultiComponent[componentId].faCheckupData,
  };
};

const mapDispatchToProps = {
  fetchFACheckup,
  fetchLookupItem,
  resetCheckUpData,
};

FACheckUp.propTypes = {
  fetchFaCheckup: PropTypes.func,
  searchParams: PropTypes.object,
  componentId: PropTypes.number,
};

FACheckUp.defaultProps = {
  fetchFaCheckup: () => {},
  searchParams: {},
  componentId: null,
};

export default compose(
  withComponentId,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(FACheckUp);
